export default {
    state: {
        device: 'mobile',
        sidebar: false,
        isMoile: false,
        routerState: false
    },
    mutations: {
        setRouterState (state) {
            state.routerState = true
        },
        setSidebar (state, value) {
            state.sidebar = value
        },
        setDevice (state, value) {
            state.device = value
        }
    },
    actions: {

    }
}
